import { render, staticRenderFns } from "./Sorgo.vue?vue&type=template&id=eb8cfaf4&scoped=true"
var script = {}
import style0 from "./Sorgo.vue?vue&type=style&index=0&id=eb8cfaf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8cfaf4",
  null
  
)

export default component.exports